import { getEncryptParams } from 'src/keycloak';
import { DataApiInputParams } from 'src/types/api';
import { appendFormData, Builder, getHeaders, getQueryString } from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';
import { getPayload } from 'src/utils/encryption';

export default (builder: Builder) => {
  return {
    getUsers: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let queryString = getQueryString(arg.params);
        let url = `keycloak/Users${
          queryString.length ? `?${queryString}` : ''
        }`;
        if (IS_ENCRYPTION_ENABLED) {
          url = `${url}${queryString.length ? '&' : '?'}payload=${btoa(
            getPayload('', getEncryptParams())
          )}`;
        }
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      },
      providesTags: ['User']
    }),
    createUser: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `keycloak/Users`;
        let formData = appendFormData(arg.params);
        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['User']
    }),
    updateUser: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `keycloak/Users`;
        let formData = appendFormData(arg.params);
        return fetchWithBQ({
          url: url,
          method: 'PUT',
          body: formData,
          ...getHeaders(url, formData)
        });
      }
    }),
    deleteUser: builder.mutation({
      async queryFn(
        args: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let formData = appendFormData(args.params);
        let url = `keycloak/Users`;
        return fetchWithBQ({
          url,
          method: 'DELETE',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['User']
    }),
    updateStatus: builder.mutation({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        let url = `keycloak/Users/update_status`;
        let formData = appendFormData(arg.params);
        return fetchWithBQ({
          url: url,
          method: 'POST',
          body: formData,
          ...getHeaders(url, formData)
        });
      },
      invalidatesTags: ['User']
    })
  };
};
